import { Col, Radio, Row, Tabs } from "antd";
import { useMemo, useState } from "react";
import KitchenCard from "./kitchenCard";

const { TabPane } = Tabs;

const KotSubscription = ({ orders, setOrders }) => {
  const [tabKey, setTabKey] = useState("1");
  const handleTabs = (key) => {
    setTabKey(key);
  };
  console.log("orders1", orders);
  const filteredOrders = useMemo(() => {
    const filterActive = orders.filter((order) => order.status !== "done");
    let breakFast = [];
    let lunch = [];
    let dinner = [];

    filterActive.forEach((order) => {
      if (order.session === "breakFast") {
        breakFast.push(order);
      }
      if (order.session === "lunch") {
        lunch.push(order);
      }
      if (order.session === "dinner") {
        dinner.push(order);
      }
    });
    return { breakFast, lunch, dinner };
  }, [orders]);

  const handleRadioChange = (v) => {
    setTabKey(v);
  };

  return (
    <>
      <Radio.Group value={tabKey} onChange={handleRadioChange} defaultValue="a">
        <Radio.Button value="1">Breakfast</Radio.Button>
        <Radio.Button value="2">Lunch</Radio.Button>
        <Radio.Button value="3">Dinner</Radio.Button>
      </Radio.Group>
      {tabKey === "1" && (
        <>
          {filteredOrders.breakFast.length === 0 && (
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                height: "calc(100vh - 100px)",
              }}
            >
              <h5>No orders</h5>
            </div>
          )}
          <Row gutter={[20, 20]}>
            {filteredOrders.breakFast?.map((item, index) => {
              return (
                item.status !== "done" && (
                  <Col key={item.billId} span={6}>
                    <KitchenCard
                      kotsub={true}
                      item={item}
                      id={index}
                      setOrders={setOrders}
                    />
                  </Col>
                )
              );
            })}
          </Row>
        </>
      )}
      {tabKey === "2" && (
        <>
          {filteredOrders.lunch.length === 0 && (
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                height: "calc(100vh - 100px)",
              }}
            >
              <h5>No orders</h5>
            </div>
          )}
          <Row gutter={[20, 20]}>
            {filteredOrders.lunch?.map((item, index) => {
              return (
                item.status !== "done" && (
                  <Col key={item.billId} span={6}>
                    <KitchenCard
                      kotsub={true}
                      item={item}
                      id={index}
                      setOrders={setOrders}
                    />
                  </Col>
                )
              );
            })}
          </Row>
        </>
      )}
      {tabKey === "3" && (
        <>
          {filteredOrders.dinner.length === 0 && (
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                height: "calc(100vh - 100px)",
              }}
            >
              <h5>No orders</h5>
            </div>
          )}
          <Row gutter={[20, 20]}>
            {filteredOrders.dinner?.map((item, index) => {
              return (
                item.status !== "done" && (
                  <Col key={item.billId} span={6}>
                    <KitchenCard
                      kotsub={true}
                      item={item}
                      id={index}
                      setOrders={setOrders}
                    />
                  </Col>
                )
              );
            })}
          </Row>
        </>
      )}
    </>
  );
};

export default KotSubscription;
